var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"personal-leave-entitlement-modal","title":"Apply New Leave","title-class":"h4 font-weight-bold","lazy":"","size":"lg","hide-footer":""}},[_c('PersonalLeaveEntitlementApplyLeaveForm',{staticClass:"mx-2",attrs:{"is-busy":_vm.isBusy},on:{"submit-clicked":_vm.submitForm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }